<template>
  <div class="adverts_detail_container">
    <div class="adverts_detail_box" v-if="detail">
      <div class="title" v-text="detail.title"></div>
      <div class="content" v-html="detail.resultContent" v-if="detail.type==2"></div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat, clickPlayCount, addScore } from "@/utils";
import commApi from "@/api/apis/common.js";
import { trackArticleDetailPg } from "@/utils/qt.js";
import advertsApi from "@/api/apis/adverts.js";
export default {
  name: "LiveDetail",
  data() {
    return {
      params: {
        adId: null,
        cId: null,
        sourceType: 4, // 1:苹果;2:安卓;3web;4:H5
      },
      detail: null,
      shareUrl: "",
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/index_share") {
        vm.shareUrl = location.href.replace("/ad_detail?", "/index_share?");
      } else {
        vm.shareUrl = location.href;
      }
    });
  },
  methods: {
    /* 获取广告详情 */
    getAdvertsDetail() {
      var _this = this;
      advertsApi
        .getPlAdInfo(_this.params)
        .then((res) => {
          if (res.suc == 1) {
            _this.detail = res.data;
            _this.statistics(); // 统计
            if (_this.detail.type == 1) {
              // 广告 type=1 外链
              window.open(_this.detail.resultContent, "_self");
            } else if (_this.detail.type == 7) {
              // 广告 type=7 内链
              _this.adToDetail();
            } else {
              _this.wechatShare(); // 微信二次分享
              _this.addScore(); // 增加积分
              // 广告 type=2 图文内容，默认显示
              // 广告 type=其他 暂不处理
            }
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: _this.shareUrl
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, _this.detail.title + " - 法治号客户端", "广告", _this.shareUrl, _this.detail.sharePictureUrl);
      }).catch((err) => {

      })
    },
    /* 统计 */
    statistics() {
      let tj_params = {
        contentCreationTime: this.detail.contentCreationTime, // 创建时间
        contentId: this.detail.adId, // 占位广告Id
        contentTitle: this.detail.title,
        contentType: 8,
        memberId: this.detail.editorId, // 当前稿件的编辑者的id
        nickName: this.detail.editor, // 当前稿件的编辑者的用户名称
      }
      clickPlayCount(tj_params);
      this.trackArticlePV();
    },
    /* 稿件详情页浏览埋点 */
    trackArticlePV() {
      const extra = {};
      if (this.detailParams.fromFlag == 1) {
        extra.specialName = this.detail.specialName;
      }
      trackArticleDetailPg(this.detail, extra);
    },
    /* 增加积分 */
    addScore() {
      let jf_params = {
        code: "xsgg", // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、gkyp、zbj、dy、dz、sc)
        description: "欣赏广告", // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、观看音频、直播间、订阅、点赞、收藏)
        contentType: 8, // 非必传，稿件的type
        contentId: this.params.adId, // 非必传，稿件的id
        contentName: this.detail.title, // 非必传，稿件的标题
      }
      if (!!this.userInfo) {
        jf_params = Object.assign(jf_params, {
          memberId: this.userInfo.id, //会员id
        });
      }
      addScore(jf_params);
    },
    /* 广告内链，跳转详情 */
    adToDetail() {
      var _this = this;
      /* 活动 */
      if (_this.detail.resultContent.contentType == 1) {
        this.$router.push({
          path: "/activity_detail",
          query: {
            contentType: _this.detail.resultContent.contentType,
            activityId: _this.detail.resultContent.contentId,
            cId: _this.detail.resultContent.cId,
          },
        });
      }
      /* 抽奖 */
      else if (_this.detail.resultContent.contentType == 2) {
        this.$router.push({
          path: "/raffle_detail",
          query: {
            contentType: _this.detail.resultContent.contentType,
            freeFlag: 0,
            drawRaffleId: _this.detail.resultContent.contentId,
            type: 0
          },
        });
      }
      /* 投票 */
      else if (_this.detail.resultContent.contentType == 3) {
        this.$router.push({
          path: "/vote_detail",
          query: {
            contentType: _this.detail.resultContent.contentType,
            id: _this.detail.resultContent.contentId,
            cId: _this.detail.resultContent.cId || 0,
          },
        });
      }
      /* 直播 */
      else if (_this.detail.resultContent.contentType == 4) {
        this.$router.push({
          path: "/live_detail",
          query: {
            contentType: _this.detail.resultContent.contentType,
            id: _this.detail.resultContent.contentId,
          },
        });
      }
      /* 图文 */
      else if (_this.detail.resultContent.contentType == 5) {
        this.$router.push({
          path: "/news_detail",
          query: {
            contentType: _this.detail.resultContent.contentType,
            contentId: _this.detail.resultContent.contentId,
          },
        });
      }
      /* 图集 */
      else if (_this.detail.resultContent.contentType == 6) {
        this.$router.push({
          path: "/gallery_detail",
          query: {
            contentType: _this.detail.resultContent.contentType,
            contentId: _this.detail.resultContent.contentId,
          },
        });
      }
      /* 图集 */
      else if (_this.detail.resultContent.contentType == 7) {
        this.$router.push({
          path: "/special_detail",
          query: {
            contentType: _this.detail.resultContent.contentType,
            contentId: _this.detail.resultContent.contentId,
            cId: _this.detail.resultContent.cId,
          },
        });
      }
      /* 视频 */
      else if (_this.detail.resultContent.contentType == 9) {
        this.$router.push({
          path: "/video_detail",
          query: {
            contentType: _this.detail.resultContent.contentType,
            contentId: _this.detail.resultContent.contentId,
          },
        });
      }
      /* 问卷 */
      else if (_this.detail.resultContent.contentType == 10) {
        this.$router.push({
          path: "/questionnaire_detail",
          query: {
            contentType: _this.detail.resultContent.contentType,
            contentId: _this.detail.resultContent.contentId,
          },
        });
      }
    },
  },
  created() {
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "adId")) {
      this.params.adId = Number(query.adId);
      this.params.cId = Number(query.cId) || 0;
      this.getAdvertsDetail();
      loadStat(); // 友盟统计
    } else if (Object.prototype.hasOwnProperty.call(query, "contentId")) {
      this.params.adId = Number(query.contentId);
      this.params.cId = Number(query.cId) || 0;
      this.getAdvertsDetail();
      loadStat(); // 友盟统计
    }
    else {
      this.$router.replace({
        path: "/error",
      });
    }
  },
};
</script>
<style scoped lang="scss">
.adverts_detail_container {
  width: 100%;
  height: 100%;
  padding: 15px;
  overflow-x: hidden;
  overflow-y: auto;
  .adverts_detail_box {
    .title {
      font-size: 24px;
      line-height: 34px;
      font-weight: bold;
      padding-bottom: 10px;
      color: #1a1a1a;
    }
    .content {
      color: #2d2d2d;
      * {
        max-width: 100%;
        white-space: normal;
        word-break: break-all;
      }
      /deep/p {
        margin: 0;
        padding: 7px 0;
        line-height: 27px;
        font-size: 18px;
        // text-indent: 2em;
        word-break: normal;
        text-align: justify;
        * {
          text-indent: 0 !important;
        }
      }
      /deep/video {
        display: block;
        max-width: 100%;
        margin: 0 auto !important;
        padding: 6px 0;
      }
      /deep/img {
        display: block;
        max-width: 100%;
        margin: 0 auto !important;
        padding: 6px 0;
      }
    }
  }
}
</style>